/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiTenantSessionDto } from './MultiTenantSessionDto';
import {
    MultiTenantSessionDtoFromJSON,
    MultiTenantSessionDtoFromJSONTyped,
    MultiTenantSessionDtoToJSON,
    MultiTenantSessionDtoToJSONTyped,
} from './MultiTenantSessionDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface TenantSwitchResponse
 */
export interface TenantSwitchResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantSwitchResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantSwitchResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantSwitchResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantSwitchResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {MultiTenantSessionDto}
     * @memberof TenantSwitchResponse
     */
    data?: MultiTenantSessionDto;
    /**
     * 
     * @type {string}
     * @memberof TenantSwitchResponse
     */
    previousTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSwitchResponse
     */
    switchedAt?: string;
}

/**
 * Check if a given object implements the TenantSwitchResponse interface.
 */
export function instanceOfTenantSwitchResponse(value: object): value is TenantSwitchResponse {
    return true;
}

export function TenantSwitchResponseFromJSON(json: any): TenantSwitchResponse {
    return TenantSwitchResponseFromJSONTyped(json, false);
}

export function TenantSwitchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSwitchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : MultiTenantSessionDtoFromJSON(json['data']),
        'previousTenantId': json['previous_tenant_id'] == null ? undefined : json['previous_tenant_id'],
        'switchedAt': json['switched_at'] == null ? undefined : json['switched_at'],
    };
}

export function TenantSwitchResponseToJSON(json: any): TenantSwitchResponse {
    return TenantSwitchResponseToJSONTyped(json, false);
}

export function TenantSwitchResponseToJSONTyped(value?: TenantSwitchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': MultiTenantSessionDtoToJSON(value['data']),
        'previous_tenant_id': value['previousTenantId'],
        'switched_at': value['switchedAt'],
    };
}

